import { useWeb3React } from 'lib/wagmi-compat/useWeb3React'
import { AuthorizationParams, User } from '@mprolab/sdk'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, AppState } from '../index'
import { setAwaitingPath, setLoadingUserData, clearUserData } from './actions'
import { useAccessToken } from './hooks/useAccessToken'
import { useUserId } from './hooks/useUserId'

export const useIsUserVerified = (): boolean => {
  const isUserVerified = useSelector<AppState, AppState['user']['isUserVerified']>((state) => {
    return state.user.isUserVerified
  })
  return isUserVerified
}

export const useUserData = (): {
  userData: User
  isLoading: boolean
  setLoading: (loading: boolean) => void
  clearData: () => void
  authParams: AuthorizationParams
  isUserVerified: boolean
} => {
  const userId = useUserId()
  const accessToken = useAccessToken()
  const { account } = useWeb3React()
  const dispatch = useDispatch<AppDispatch>()
  const userData = useSelector<AppState, AppState['user']['user']>((state) => {
    return state.user.user
  })
  const isLoading = useSelector<AppState, AppState['user']['loadingUserData']>((state) => {
    return state.user.loadingUserData
  })

  const isUserVerified = useSelector<AppState, AppState['user']['isUserVerified']>((state) => {
    return state.user.isUserVerified
  })

  const clearData = useCallback(() => {
    dispatch(clearUserData())
  }, [dispatch])

  const setLoading = useCallback(
    (loading: boolean) => {
      dispatch(setLoadingUserData(loading))
    },
    [dispatch]
  )

  const authParams = {
    userId,
    accessToken,
    account
  }

  return { userData, isLoading, setLoading, clearData, authParams, isUserVerified }
}

export function useAwaitingPath(): { updateAwaitingPath: (path: string) => void; awaitingPath: string } {
  const dispatch = useDispatch<AppDispatch>()
  const awaitingPath = useSelector<AppState, AppState['user']['awaitingPath']>((state) => {
    return state.user.awaitingPath
  })

  const updateAwaitingPath = useCallback(
    (path: string) => {
      dispatch(setAwaitingPath(path))
    },
    [dispatch]
  )

  return { updateAwaitingPath, awaitingPath }
}
